import React, { Component } from 'react';
import map from 'lodash/map';

import { Layout } from '../../Common/Component';

import calendar_1 from '../../../Assets/images/calendar_1.svg';
import calendar_2 from '../../../Assets/images/calendar_2.svg';
import calendar_3 from '../../../Assets/images/calendar_3.svg';
import calendar_4 from '../../../Assets/images/calendar_4.svg';
import calendar_5 from '../../../Assets/images/calendar_5.svg';
import special_offer from '../../../Assets/images/special_offer.png';
import about_bottom_dog from '../../../Assets/images/about_bottom_dog.png';
import subscription_about_img from '../../../Assets/images/subscription_about_img.png';

class Subscription extends Component {
  state = {
    pricing_range: [],
    loader: false
  }

  componentDidMount = () => {
    const zipcode = JSON.parse(sessionStorage.getItem('area'));
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('step2');
    sessionStorage.removeItem('current');

    if (zipcode) {
      this.setState({loader: true});
      this.props.getPriceList(zipcode['uuid']);
    }
    else {
      window.location.assign('/');
    }
  };

  UNSAFE_componentWillReceiveProps = (props) => {
    let is_edit = JSON.parse(localStorage.getItem('is_edit'));

    if (is_edit && is_edit.frequency && is_edit.frequency === 'once') {
      if (Object.keys(props.PriceList.data).length > 0) {
        this.setState({loader: false});

        map(props.PriceList.data.pricing_range, (item) => {
          if (item.frequency === "once") {
            this.props.history.push('/getquote', {
              query: { frequency_price: item },
            });
          }
        });
      }
    }

    if (Object.keys(props?.PriceList?.data).length > 0 && this.props?.PriceList?.data !== props?.PriceList?.data) {
      this.setState({
        loader: false,
        pricing_range: props?.PriceList?.data?.pricing_range
      });
    }
  }

  // Render Price List
  renderPriceList = (pricingRange) => {
    if (!pricingRange || pricingRange.length === 0) return;
    const orderedPricingRange = [
      pricingRange.find(x => x.frequency === "twice_weekly"),
      pricingRange.find(x => x.frequency === "weekly"),
      pricingRange.find(x => x.frequency === "bi_monthly"),
      pricingRange.find(x => x.frequency === "monthly"),
      pricingRange.find(x => x.frequency === "once"),
    ];

    return map(orderedPricingRange, (item, i) => {
      return (
        <div
          className='option_list_item'
          key={i}
          onClick={() => {
            this.props.updateCustomerLastCompletedStep({
              step: 2,
              tracking_uuid: JSON.parse(sessionStorage.getItem("tracking_uuid"))
            });

            this.props.history.push('/getquote', {
              query: { frequency_price: item },
            });
          }}
        >
          <div
            className={
              item.frequency === 'weekly'
                ? 'subscription_box active_box'
                : 'subscription_box'
            }
          >
            {item.frequency === 'weekly' &&
              <div className='special_offer_back'>
                <img src={special_offer} alt="" />
              </div>
            }
            <label>
              {item.frequency === 'bi_monthly'
                ? 'Every Other Week'
                : item.frequency === 'once'
                  ? 'Just Once'
                  : item.frequency === 'twice_weekly'
                    ? 'Twice Weekly'
                    : item.frequency}
            </label>
            <span>starting at ${item.min_price}/visit</span>
            <div className='img_div'>
              <img
                src={
                  item.frequency === 'twice_weekly'
                    ? calendar_2
                    : item.frequency === 'weekly'
                      ? calendar_1
                      : item.frequency === 'monthly'
                        ? calendar_4
                        : item.frequency === 'once'
                          ? calendar_5
                          : calendar_3
                }
                alt="" />
            </div>
            <button
              type='button'
              className='btn'
            >
              Get Started
            </button>
          </div>
        </div>
      );
    });
  };

  render() {
    const zipcode = JSON.parse(sessionStorage.getItem('area'));
    const { pricing_range, loader } = this.state;

    return (
      <Layout >
        <div className='page_inner_content'>
          <div className='page_header'>
            <div className='container dog_bg_img'>
              <div className='row'>
                <div className='col-md-8'>
                  <h1 className='heading'>
                    Welcome to DoodyCalls of {zipcode && `${zipcode['city']},${zipcode['state']}`}
                  </h1>
                  <span className='sub_heading'>
                    Making the world a happier and healthier place for people and pets
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='subscription_list'>
            <div className='container'>
              <div className='row'>
                <div className='col-md-12'>
                  <label
                    className='back_arrow cursor_pointer'
                    onClick={() => window.history.back()}
                  >
                    <i className='las la-arrow-left'></i>
                    Back{' '}
                  </label>
                </div>
                <div className='col-md-12'>
                  <h2 className='section_title mb-10'>
                    How often do you need your yard cleaned?
                  </h2>
                </div>
              </div>
              <div className="mobile_responsive_scroll">
                <div className='option_list'>{this.renderPriceList(pricing_range)}</div>
              </div>
            </div>
          </div>
          <div className='how_its_works'>
            <div className='container'>
              <div className='row'>
                <div className='col-md-6 col-lg-4 offset-lg-2'>
                  <h2>How service works</h2>
                  <div className='details_box'>
                    <h3 className='details_heading'>
                      Fetch quote & schedule your service
                    </h3>
                    <p className='details'>
                      Cleaning frequencies include twice weekly, weekly, every other week, monthly and one time cleanings. Service frequency can be easily updated online any time.
                    </p>
                  </div>
                  <div className='details_box'>
                    <h3 className='details_heading'>We’ll clean your yard on your schedule</h3>
                    <p className='details'>
                      Our trained technicians will come remove pet waste from your yard and let you know when it’s done, all hassle-free for you.
                    </p>
                  </div>
                  <div className='details_box'>
                    <h3 className='details_heading'>
                      Get out and enjoy your yard!
                    </h3>
                    <p className='details'>
                      Spend your time on the stuff that matters, like enjoying your clean yard with the whole family. We’ve got you covered.
                    </p>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className="people_img">
                    <img src={subscription_about_img} alt="" />
                    <div className='dog_img'>
                      <img
                        src={about_bottom_dog}
                        className='img-fluid'
                        alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {loader &&
          <div className='loader_wrapper'>
            <div className='loader07'></div>
          </div>
        }
      </Layout>
    );
  }
}

export default Subscription;